import { createImageUpload } from "novel";
import { TextSelection, NodeSelection } from "@tiptap/pm/state";
import { errorToast } from "../../util/toastNotifications";
import { apiUrl } from "../../environmentConfig";

const buildOnUpload =
  ({ taskId, orgId } = {}) =>
  async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    if (taskId) formData.append("task_id", taskId);
    if (orgId) formData.append("org_id", orgId);

    const response = await fetch(`${apiUrl}/file`, {
      method: "POST",
      body: formData,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Image upload failed");
    }

    const data = await response.json();
    return data.results.file_url;
  };

const validateFn = (file) => {
  const isImage = file.type.startsWith("image/");

  if (!isImage) {
    errorToast("File type not supported. Please use an image file.");
    return false;
  }
  if (file.size / 1024 / 1024 > 20) {
    errorToast("File size too large. Maximum size is 20MB.");
    return false;
  }
  return true;
};

export const uploadFn = createImageUpload({
  onUpload: buildOnUpload(),
  validateFn,
});

export const createUploadFn = (context) =>
  createImageUpload({
    onUpload: buildOnUpload(context),
    validateFn,
  });

const placeImageNode = (view, node, pos) => {
  const { schema } = view.state;
  let tr = view.state.tr;
  if (pos != null) {
    const safePos = Math.max(0, Math.min(pos, view.state.doc.content.size));
    tr = tr.setSelection(TextSelection.near(tr.doc.resolve(safePos)));
  }
  tr = tr.replaceSelectionWith(node);

  if (tr.selection instanceof NodeSelection && schema.nodes.paragraph) {
    const after = tr.selection.to;
    tr = tr.insert(after, schema.nodes.paragraph.create());
    tr = tr.setSelection(TextSelection.near(tr.doc.resolve(after + 1)));
  }

  view.dispatch(tr.scrollIntoView());
  view.focus();
};

export const insertImageAsBase64 = (view, file, pos) => {
  if (!validateFn(file)) return;
  const reader = new FileReader();
  reader.onload = () => {
    if (typeof reader.result !== "string") return;
    const { schema } = view.state;
    if (!schema.nodes.image) return;
    placeImageNode(view, schema.nodes.image.create({ src: reader.result }), pos);
  };
  reader.readAsDataURL(file);
};
